import { TemplateDisplayV3 } from "@workspace/common";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

function OfferPreviewModal({
  isOpen,
  toggle,
  selectedCandidate,
  offerPDFFile,
}) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered scrollable size="xl">
      <ModalHeader className="bg-primary" toggle={toggle}>
        {`${selectedCandidate?.candidate?.firstName} ${selectedCandidate?.candidate?.lastName} Offer`}
      </ModalHeader>
      <ModalBody>
        <object
          data={offerPDFFile}
          type="application/pdf"
          width="100%"
          height="500px"
        ></object>
      </ModalBody>
    </Modal>
  );
}

export default OfferPreviewModal;
